import { render, staticRenderFns } from "./RaceConfigModal.vue?vue&type=template&id=ea133146&scoped=true&"
import script from "./RaceConfigModal.vue?vue&type=script&lang=js&"
export * from "./RaceConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./RaceConfigModal.vue?vue&type=style&index=0&id=ea133146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea133146",
  null
  
)

export default component.exports